import { createEntityAdapter, createSelector } from '@reduxjs/toolkit'
import { filter } from 'lodash'

import { RootState } from '../../store'
import { File, FileUploadState } from '../../types'

export const filesAdapter = createEntityAdapter({
  selectId: (file: File) => file.clientId,
})

const filesSelector = filesAdapter.getSelectors<RootState>(state => state.files)

export default filesSelector

export const getAllFiles = (state: RootState) => filesSelector.selectAll(state)

export const getUploadingFiles = createSelector([getAllFiles], files =>
  filter(files, (file: File) => FileUploadState.Uploading === file.state)
)

export const isUploading = createSelector([getUploadingFiles], files => 0 < files.length)

export const getUploadedFiles = createSelector([getAllFiles], files =>
  filter(files, (file: File) => FileUploadState.Uploaded === file.state)
)
